module.exports = __webpack_public_path__ + "img/img-testimonial-logo-1.5193406.png";